import AttendAgreement36 from './AttendAgreement36'

export default AttendAgreement36;